export default {
  'validator.alphaNumeric': 'Must be alphanumeric',
  'validator.arrayNotEmpty': 'Required',
  'validator.emailAddress': 'Must be a valid email address',
  'validator.invalid': 'Invalid',
  'validator.isNumeralsOnly': 'Only supports numeric values',
  'validator.isNumeric': 'Must be numeric',
  'validator.maxLength': 'Must be less than {1} characters long',
  'validator.maxValue': 'Must be less than or equal to {1}',
  'validator.maxValueExclusive': 'Must be less than {1}',
  'validator.minLength': 'Must be at least {1} characters long',
  'validator.minValue': 'Must be greater than or equal to {1}',
  'validator.minValueExclusive': 'Must be greater than {1}',
  'validator.required': 'Required',
  'validator.us10DigitPhone': 'Must be a valid 10 digit US phone number',
  'validator.usZipCode': 'Must be a valid US zip code',
};
